import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.TimbradoFactura;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un timbrado
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un timbrado
*/
export class TimbradoFacturaNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    OnObtenerXML = async () => {
        const value = this.props.value;
        const comprobanteXML = await resources.Factura.ObtenerXML(value.IdFactura);
        kea.download(kea.base64ToBlob(comprobanteXML, 'application/xml'), "Comprobante.xml");
    }

    OnObtenerPDF = async () => {
        const value = this.props.value;
        const facturaPDF = await resources.Factura.ObtenerPDF(value.IdFactura);
        kea.download(kea.base64ToBlob(facturaPDF, 'application/pdf'), "Comprobante.pdf");
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const DateTime = getField(kea.DateTime);
        const Text = getField(kea.Text);

        return (
            <div>
                <kea.Title titulo="Timbrado" onRegresar={() => history.go("/operativa/Facturas")} >
                    <kea.Button iconClass={fa("file-code-o")} tooltip="Obtener archivo xml de la factura expedido por el SAT" children="Descargar XML" style="primary" onClick={this.OnObtenerXML} />
                    <kea.Button iconClass={fa("file-pdf-o")} tooltip="Obtener archivo pdf de la factura" children="Descargar PDF" style="danger" onClick={this.OnObtenerPDF} />
                </kea.Title>
                {kea.autogrid(3, [
                    <Text field="Version" label="Versión del timbre:" readonly={true} />,
                    <Text field="UUID" label="Folio fiscal (UUID):" readonly={true} />,
                    <DateTime field="FechaTimbrado" label="Fecha de timbrado:" readonly={true} />,
                    <Text field="NoCertificadoSAT" label="No. Certificado del SAT:" readonly={true} />,
                ])}
                {kea.autogrid(12, [
                    <Text field="SelloCFD" label="Sello CFD::" multiline={true} readonly={true} />,
                    <Text field="SelloSAT" label="Sello SAT::" multiline={true} readonly={true} />
                ])}
            </div>);
    }
}

export const TimbradoFactura = componentToRx(TimbradoFacturaNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/informaciontimbrado.tsx